export const invoices = {
  alerts: {
    errorDuplicateEntryNumber: 'Factuurnummer “{{entryNumber}}” heb je al eens gebruikt.',
    missingFcFiles_one: 'De pdf voor deze factuur is niet terug te vinden.',
    missingFcFiles_other: 'De pdf’s voor deze facturen zijn niet terug te vinden.',
    successCreated: 'Je factuur is aangemaakt.',
    successDeleted: 'Je concept is verwijderd.',
    successResendCoInvoice: 'Je factuur is opnieuw verstuurd.',
    successUpdated: 'Je factuur is bewerkt.',
  },
  breadcrumb: {
    create: 'Details',
    noTitle: 'Geen titel',
    overview: 'Facturen',
  },
  conditionDialog: {
    title: 'Algemene voorwaarden',
  },
  createEdit: {
    advantageSimulationModal: {
      distribution: {
        commission: {
          descriptionWithCs:
            'De vergoeding aan Creative Shelter. Deze wordt berekend per factuur, op basis van <a href="https://my.creativeshelter.be/settings/plan">je huidige vergoeding</a> en wordt afgehouden van het bedrag exclusief btw dat je factureerde aan je klant. Wij nemen alle administratieve rompslomp op ons zodat jij auteursrechten kan factureren en dus zo meer verdient op het einde van de rit.',
          descriptionWithCsMinimumCommissionApplied:
            'De vergoeding aan Creative Shelter. Omdat je factuurbedrag aan de lagere kant is, is de minimumvergoeding van € 12,50 van toepassing. Twijfel je of je er nog steeds een netto-voordeel uithaalt? Neem contact met ons op, dan bekijken we het samen!',
          disclaimerWithCs: '',
          label: 'Vergoeding Creative Shelter',
        },
        costs: {
          descriptionWithCs:
            'We houden rekening met 20% kosten van het totale factuurbedrag. Dit is een schatting, dit kan hoger of lager liggen, al is dit een realistisch gemiddelde.',
          descriptionWithoutCs:
            'We houden rekening met 20% kosten van het totale factuurbedrag. Dit is een schatting, dit kan hoger of lager liggen, al is dit een realistisch gemiddelde.',
          disclaimerWithCs: '',
          disclaimerWithoutCs: '',
          label: 'Kosten',
        },
        netAmount: {
          descriptionWithCs:
            'Het bedrag dat je netto overhoudt als je factureert met Creative Shelter, na het afhouden van onze vergoeding, kosten, sociale bijdragen, belastingen, … Zo zie je het zelf, zwart op wit, Creative Shelter loont!',
          descriptionWithCsNoAdvantage:
            'Uit deze factuur zal je volgens onze schatting geen voordeel halen. Als je voornamelijk of uitsluitend niet-creatieve prestaties factureert, zal het voordeliger zijn om deze factuur niet via ons te versturen. Twijfel je? Neem gerust contact op met ons, dan bekijken we dit samen!',
          descriptionWithoutCs:
            'Het bedrag dat je netto overhoudt als je factureert zonder Creative Shelter, na het afhouden van kosten, sociale bijdragen, belastingen, …\nVergelijk zeker eens, Creative Shelter loont!',
          disclaimerWithCs: '',
          disclaimerWithoutCs: '',
          label: 'Netto-inkomsten',
        },
        socialContribution: {
          descriptionWithCs:
            'Je factuur wordt volgens de verdeelsleutel opgesplitst in een deel auteursrechten en een deel beroepsinkomsten. Op je beroepsinkomsten (na aftrek van de kosten die je inbrengt) zal je 20,5% sociale bijdragen moeten betalen. Dit zijn de voorlopige bijdragen voor je sociaal verzekeringsfonds, waarmee je sociale rechten opbouwt.',
          descriptionWithoutCs:
            'Op het volledige factuurbedrag, na aftrek van de kosten die je inbrengt, zal je 20,5% sociale bijdragen moeten betalen. Dit zijn de voorlopige bijdragen voor je sociaal verzekeringsfonds, waarmee je sociale rechten opbouwt.',
          disclaimerWithCs:
            'Het bedrag zal lager zijn dan zonder Creative Shelter, aangezien je een deel van je inkomsten als vergoeding voor auteursrechten ontvangt.',
          disclaimerWithoutCs: '',
          label: 'Sociale bijdrage',
        },
        taxes: {
          descriptionWithCs:
            'Je factuur wordt volgens de verdeelsleutel opgesplitst in een deel auteursrechten en een deel beroepsinkomsten. Enkel op dit laatste deel zal je personenbelasting moeten betalen (na aftrek van je kosten en sociale bijdrage).',
          descriptionWithoutCs:
            'Op het volledige factuurbedrag, na aftrek van je kosten en sociale bijdragen, betaal je personenbelasting. Hoeveel je betaalt, hangt af van je burgerlijke status en je inkomsten. Hoe hoger je inkomsten, hoe meer belastingen je zult betalen. En gezien er geen verdeelsleutel aan te pas komt, ligt dit hoger dan als je zou factureren met auteursrechten.',
          disclaimerWithCs:
            'Het gemiddelde belastingpercentage zal lager zijn, gezien je beroepsinkomsten ook verminderd zijn. We rekenen hier op een percentage tussen de 0% en 30%, afhankelijk van de verdeling van je specifieke factuur.',
          disclaimerWithCsNotMainOccupation:
            'Je gaf aan actief te zijn in bijberoep en we gaan ervan uit dat je in hoofdberoep ook inkomsten ontvangt. Voor de berekening van het deel belastingen, houden we rekening met een percentage van 45%.',
          disclaimerWithoutCs: '',
          label: 'Belastingen',
        },
        withholdingTaxes: {
          descriptionWithCs:
            'De roerende voorheffing is een belasting die wordt berekend op je vergoeding voor auteursrechten. Deze berekenen we automatisch voor jou, houden we af en storten we door naar de fiscus. Zelf hoef je hier niets voor te doen, maar zo ontvang je op een correcte manier een vergoeding voor auteursrechten.\n\nLees je er graag meer over, dat kan <a href="https://knowledge.creativeshelter.be/wat-is-roerende-voorheffing-en-hoe-wordt-deze-berekend" target="_blank">hier</a>!',
          disclaimerWithCs: '',
          label: 'Roerende voorheffing',
        },
      },
      label: {
        withCs: 'Met Creative Shelter',
        withoutCs: 'Zonder Creative Shelter',
      },
      noDataDisclaimer: 'Het voordeel kan nog niet berekend worden. Vul je factuur aan en zorg dat je minstens één lijn hebt toegevoegd.',
      title: 'Simulatie voordeel',
      toggle: {
        withCs: 'Met Creative Shelter',
        withoutCs: 'Zonder Creative Shelter',
      },
      totals: {
        advantage: 'Voordeel Creative Shelter',
        netAmount: 'Netto-inkomsten',
        noAdvantage: 'Geen voordeel',
        totalInvoiced: 'Klantenfactuur',
      },
    },
    assignment: {
      description: 'Beschrijf kort wat je opdracht zoal inhoudt.',
      fieldLabel: 'Informatie over de opdracht',
      title: 'Opdracht',
    },
    attachments: {
      attachment: 'Bijlage',
      description: 'Voeg eventuele documenten toe aan deze factuur.',
      error: {
        delete: 'Er ging iets mis bij het verwijderen van de bijlage.',
      },
      title: 'Bijlagen',
    },
    automaticApprovalModal: {
      automatic: 'Instant factureren',
      description:
        'Je factuur kan direct worden goedgekeurd. Je kan er toch voor kiezen om je factuur door ons te laten nakijken, dan duurt de goedkeuring iets langer.',
      manual: 'Manueel goedkeuren',
      title: 'Instant factureren',
    },
    basicInfo: {
      description: 'Alle basisinformatie van je factuur.',
      title: 'Basisinformatie',
    },
    blocker: {
      leave: 'Verlaten zonder versturen',
      leaveUnsaved: 'Verlaten zonder opslaan',
      message:
        'Ben je zeker dat je de pagina wilt verlaten? Je factuur blijft in bewerking tot je ze opnieuw verstuurt, en zolang kunnen we ze niet goedkeuren.',
      messageUnsaved:
        'Ben je zeker dat je de pagina wilt verlaten? Je wijzigingen zijn niet opgeslagen. Je factuur blijft in bewerking tot je ze opnieuw verstuurt, en zolang kunnen we ze niet goedkeuren.',
    },
    clientInfo: {
      addEmailReceiver: 'Ontvanger toevoegen',
      emailSelfTooltip: 'Je hebt ervoor gekozen om facturen en creditnota’s zelf door te sturen naar je klant.',
      peppol: 'Verstuurd via Peppol',
    },
    clientModal: {
      addContact: 'Contactpersoon toevoegen',
      cancel: 'Annuleren',
      confirm: 'Bevestigen',
      contactsLegend: 'Kies een contactpersoon',
      emptyList: 'Geen klanten gevonden.',
      newClient: 'Nieuwe klant',
      searchPlaceholder: 'Zoek een klant',
      title: 'Voeg een klant toe',
      typeFilter: {
        all: 'Alle types',
        organisation: 'Organisatie',
        private: 'Particulier',
      },
    },
    coTooLowModal: {
      description:
        'Het bedrag dat je wilt factureren is te laag, na onze vergoeding zou je niets meer overhouden.\n\nPas je factuur aan door het bedrag te verhogen, of verstuur ze buiten het platform.',
      dismiss: 'Ik snap het!',
      title: 'Je factuurbedrag is te laag',
    },
    conditions: {
      customCondition: {
        description: 'Kies een van je eigen, op maat gemaakte voorwaarden.',
        placeholder: 'Kies je voorwaarden',
        title: 'Eigen voorwaarden',
      },
      description: 'Kies hier hoe jij je auteursrechten wilt overdragen aan je klant.',
      specialConditionsAction: 'Bijzondere voorwaarden',
      title: 'Hoe draag je je auteursrechten over?',
      tooltip: 'De custom algemene voorwaarden zijn enkel in het Nederlands beschikbaar.',
      transfer: {
        description: 'Je draagt de rechten over naar je klant, na betaling van de factuur.',
      },
      usageRight: {
        description: 'Je verleent een gebruiksrecht aan je klant, zo behoud jij de rechten.',
      },
      viewPdf: 'Voorwaarden nalezen',
    },
    confirmation: {
      description: 'Alle informatie ingevuld, is je factuur volledig? Wij controleren deze grondig en keuren deze erna goed.',
      descriptionEdit:
        'Factuur aangepast, klaar om deze nog eens te versturen? Zodra je dit doet, kunnen we deze goedkeuren. Nog niet klaar? Sla je factuur op zonder ze te versturen.',
      entryNumber: {
        close: 'Aanpassing sluiten',
        confirm: 'Aanpassing bevestigen',
        creditNoteNumber: 'Creditnotanummer',
        decrease: 'Volgnummer verminderen',
        edit: 'Volgnummer aanpassen',
        increase: 'Volgnummer verhogen',
        invoiceNumber: 'Factuurnummer',
        prefix: 'Prefix',
        reset: 'Volgnummer terugzetten',
        serialNumber: 'Volgnummer',
        suffix: 'Suffix',
        warning:
          'De nummeringreeks zorgt ervoor dat je documenten automatisch correct genummerd worden. Aanpassen mag en kan, maar daar ben jij verantwoordelijk voor.',
      },
      minCommission: 'De minimumvergoeding van € 12,50 is van toepassing op deze factuur.',
      sentWithPeppol: 'Je factuur wordt na goedkeuring via Peppol verstuurd.',
      sentWithPeppolInstant: 'Je factuur wordt via Peppol verstuurd.',
      submit: {
        create: 'Ja, factuur aanmaken',
        edit: 'Ja, factuur versturen',
        saveAndExit: 'Opslaan en verlaten',
      },
      title: 'Je factuur wordt naar ons gestuurd',
      titleEdit: 'Je factuur wordt opnieuw naar ons gestuurd',
    },
    invoiceDetails: {
      dueDate: 'Vervaldatum',
      dueDatePlaceholder: 'Selecteer een vervaldatum',
      numberingSeriesPlaceholder: 'Kies een nummeringreeks',
      title: 'Factuurdetails',
    },
    lines: {
      description: 'Lijst hier de producten en/of diensten op die je aanbiedt.',
      title: 'Factuurlijnen',
    },
    preview: 'Voorbeeld',
    remark: {
      description: 'Opmerkingen of vragen aan Creative Shelter.',
      title: 'Opmerkingen',
    },
    saveAndExitDialog: {
      description:
        'Je wijzigingen worden opgeslagen, maar je factuur blijft in bewerking. Zolang je ze niet opnieuw verstuurt, kunnen we ze niet goedkeuren.',
      saveAndExit: 'Opslaan en verlaten',
      send: 'Toch versturen',
      title: 'Factuur opslaan zonder te versturen?',
    },
    submit: {
      saveAndExit: 'Opslaan en verlaten',
      saveSend: 'Opslaan & versturen',
    },
    title: {
      create: 'Concept factuur',
      edit: 'Bewerk factuur',
    },
    vatExemptLimit: {
      exceeded: {
        buttonText: 'Ik snap het!',
        description:
          'Je totale omzet is meer dan € 25.000. De standaard btw-vrijstellingsregeling mag je bijgevolg ook niet meer gebruiken. Pas je eerst je btw-statuut aan voor je verdergaat met factureren? Meer informatie vind je <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">hier</a> terug.',
        title: 'Limiet bereikt',
      },
      firstWarning: {
        buttonText: 'Oké, begrepen!',
        description:
          'Je totale omzet nadert de € 25.000. Boven die grens kan je de standaard btw-vrijstellingsregeling niet meer gebruiken. Hou je omzet daarom goed in de gaten.',
        title: 'Bijna aan de limiet',
      },
      secondWarning: {
        buttonText: 'Oké, ik snap het!',
        description:
          'Je totale omzet nadert de € 25.000. Om gebruik te mogen maken van de standaard btw-vrijstellingsregeling, mag je hier niet over gaan. Pas je btw-statuut op tijd aan.',
        title: 'Limiet bijna bereikt',
      },
    },
  },
  details: {
    confirmDownloadFcInvoiceModal: {
      buttonText: 'Oké, begrepen!',
      description: 'Deze factuur is alleen voor jouw boekhouding, stuur deze dus niet door naar je klant.',
      peppol: 'De factuur ontving je al via je Peppol-inbox. Hier kan je ze opnieuw downloaden.',
      title: 'Opgelet!',
    },
    confirmEditModal: {
      bodyLocked:
        'Deze factuur staat nog in bewerkmodus. En net daarom kunnen we deze nog niet goedkeuren. Ben je klaar, alles aangevuld/aangepast? Vergeet dan niet om je factuur opnieuw te versturen.',
      bodyPending:
        'Deze factuur staat ter goedkeuring. Bewerken kan nog, maar vergeet dan niet om deze nog eens opnieuw te versturen als je klaar bent.',
      confirm: 'Ik snap het',
      title: 'Opgelet!',
    },
    confirmResendCoInvoiceModal: {
      confirm: 'Oké, versturen',
      descriptionSendFromCreativeShelter: 'Je klant zal de factuur zo opnieuw ontvangen, met jou in cc.',
      descriptionSendFromFreelancer:
        'Je vinkte aan dat je de facturen zelf verstuurt. Je ontvangt deze dus zelf om ze nadien naar je klant te mailen.',
      title: 'Dubbelcheck',
    },
    copyright: {
      label: 'Auteursrechten',
      subtitle: 'Je auteursrechten',
      viewDocument: 'Document nalezen',
    },
    error: {
      title: 'Fout bij het laden van je factuur.',
    },
    followUp: {
      modal: {
        accept: 'Starten',
        addRemark: 'Opmerking toevoegen',
        input: {
          placeholder: 'Eventuele opmerking',
        },
        message:
          'Je klant ontving automatische herinneringsmails voor je factuur, maar er volgde geen betaling. Door een opvolging te starten, nemen we persoonlijk contact op met je klant voor de betaling van je factuur.\n\nMogen we deze opvolging opstarten?',
        remarkMessage:
          'Heb je nog extra informatie of een opmerking voordat we starten met de opvolging van je factuur? Die vul je hier in.\n\nAndere vragen? Mail naar administratie@creativeshelter.be.',
        title: 'Opvolging starten',
        titleRemark: 'Opvolging gestart',
      },
      start: 'Opvolging van onbetaalde factuur starten',
    },
    history: {
      error: {
        title: 'Fout bij het laden van de historiek.',
      },
      message: {
        Approved: {
          default: 'Goedgekeurd',
          instant: 'Instant goedgekeurd',
        },
        Created: {
          default: 'Aangemaakt als concept',
        },
        CreditNoteApproved: {
          default: 'Creditnota goedgekeurd door Creative Shelter',
        },
        CreditNoteEmailApprovedAndSent: {
          client: 'Creditnota verstuurd naar je klant',
          user: 'Creditnota verstuurd naar je e-mailadres',
        },
        Credited: {
          default: 'Gecrediteerd',
        },
        EmailApprovedAndSent: {
          client: 'Factuur verstuurd naar je klant',
          user: 'Factuur verstuurd naar je e-mailadres',
        },
        EmailPaymentReminder: {
          first: 'Eerste herinneringsmail (automatisch) verstuurd naar je klant',
          second: 'Tweede herinneringsmail (automatisch) verstuurd naar je klant',
        },
        Expired: {
          default: 'Vervallen',
        },
        Finalized: {
          default: 'Verstuurd ter goedkeuring',
        },
        FollowUpContactClientByPhone: {
          default: 'Telefonisch contact door administratie Creative Shelter',
        },
        FollowUpFormalNoticeSent: {
          default: 'Ingebrekestelling opgesteld en verstuurd',
        },
        FollowUpInvoiceSentToBailiff: {
          default: 'Opvolging door de deurwaarder gestart',
        },
        FollowUpInvoiceSentToLawyer: {
          default: 'Ingebrekestelling verstuurd door de advocaat',
        },
        FollowUpLastManualReminder: {
          default: 'Laatste herinneringsmails verstuurd door administratie Creative Shelter',
        },
        FollowUpManualReminder: {
          default: 'Herinneringsmails verstuurd door administratie Creative Shelter',
        },
        FollowUpStarted: {
          default: 'Betalingsopvolging gestart',
        },
        LockedByUser: {
          default: 'In bewerking geplaatst',
        },
        PaidByClient: {
          default: 'Betaald door je klant',
        },
        PaidByCreativeShelter: {
          default: 'Betaald aan jou door Creative Shelter',
        },
        PartiallyPaid: {
          default: 'Gedeeltelijke betaling ontvangen van {{amount}}',
        },
        PeppolCoAccepted: {
          creditNote: 'Creditnota geaccepteerd via Peppol door je klant',
          default: 'Geaccepteerd via Peppol door je klant',
        },
        PeppolCoDelivered: {
          creditNote: 'Creditnota aangekomen in de Peppol-inbox van je klant',
          default: 'Aangekomen in de Peppol-inbox van je klant',
        },
        PeppolCoRefused: {
          creditNote: 'Creditnota geweigerd via Peppol door je klant',
          default: 'Geweigerd via Peppol door je klant',
        },
        PeppolCoSent: {
          creditNote: 'Creditnota verstuurd via Peppol naar je klant',
          default: 'Verstuurd via Peppol naar je klant',
        },
        PeppolFcAccepted: {
          creditNote: 'Creditnota geaccepteerd via Peppol door jou',
          default: 'Geaccepteerd via Peppol door jou',
        },
        PeppolFcDelivered: {
          creditNote: 'Creditnota aangekomen in je Peppol-inbox',
          default: 'Aangekomen in je Peppol-inbox',
        },
        PeppolFcRefused: {
          creditNote: 'Creditnota geweigerd via Peppol door jou',
          default: 'Geweigerd via Peppol door jou',
        },
        PeppolFcSent: {
          creditNote: 'Creditnota verstuurd via Peppol naar jou',
          default: 'Verstuurd via Peppol naar jou',
        },
      },
    },
    paymentInfo: {
      alreadyPaid: 'Al betaald',
      dueDate: 'Vervaldatum',
      expectedPaidDate: 'Verwachte betaaldatum',
      expectedPaidDateTooltip:
        'Jij ontvangt de betaling van Creative Shelter, de eerste werkdag nadat wij de betaling van je klant ontvingen.',
      paidDate: 'Betaaldatum',
      partialPayment: 'Betaling {{number}}',
      remaining: 'Nog te betalen',
      status: {
        options: {
          credited: 'Gecrediteerd',
          fcPaid: 'Uitbetaald',
          notPaid: 'Openstaand',
          paid: 'Betaald',
        },
      },
      transportType: {
        label: 'Verzendmethode',
        options: {
          Email: 'E-mail',
          Peppol: 'Peppol',
        },
      },
      vatExceptionallyExempt: 'Vrijgesteld',
      withholdingTax: 'Roerende voorheffing',
    },
    paymentInfoDetail: {
      remark: {
        byAdmin: 'Opmerking van {{name}}.',
        byUser: 'Je opmerking',
      },
      types: {
        FollowUpContactClientByPhone: {
          description: 'We bellen je klant voor een update van je onbetaalde factuur. Is er nieuws? Dan brengen we je op de hoogte.',
        },
        FollowUpFormalNoticeSent: {
          description:
            'Er is een ingebrekestelling verstuurd naar je klant. Deze wordt verstuurd via e-mail en de post, om zeker te zijn dat die hen bereikt.',
        },
        FollowUpInvoiceSentToBailiff: {
          description: 'Er is een gerechtsdeurwaarder aangesteld. Die neemt het dossier over en het contact met je klant.',
        },
        FollowUpInvoiceSentToLawyer: {
          description:
            'Er is een ingebrekestelling verstuurd via een partneradvocaat. Deze wordt verstuurd via e-mail en de post, om zeker te zijn dat die hen bereikt.',
        },
        FollowUpLastManualReminder: {
          description:
            'Je klant ontving al verschillende reminders (via e-mail en telefonisch), maar een betaling volgde nog niet.\n<br>\nEr volgt een allerlaatste manuele reminder. Komt er geen reactie of update over de betaling? Dan kunnen we extra stappen ondernemen.',
        },
        FollowUpManualReminder: {
          description: 'Een eerste manuele reminder is verstuurd naar je klant. Zodra er een update is, laten we iets weten.',
        },
        FollowUpStarted: {
          description:
            'We volgen je onbetaalde factuur verder op. Starten doen we met extra reminders en telefonisch contact.\n<br>\nLukt het zo niet? Dan volgen extra stappen: een ingebrekestelling, een tweede via onze partneradvocaat en eventueel de deurwaarder (binnen België).\n<br>\nZodra er nieuws is, geven we een seintje.',
        },
      },
    },
    split: {
      amount: 'Bedrag',
      amountExclVat: 'Bedrag (excl. btw)',
      co: {
        description: 'Je klant ontvangt deze factuur en betaalt aan Creative Shelter.',
        eyebrow: 'Factuur voor je klant',
        highlight: 'Je klant betaalt',
        preview: 'De factuur bekijken',
      },
      copyrightGroup: 'Auteursvergoeding',
      copyrightTotal: 'Totaal auteursrechten (netto)',
      description: 'Zodra je factuur is goedgekeurd, maken we automatisch 2 facturen aan. Dit is waarom:',
      fc: {
        description: 'Zodra je klant betaalt, storten wij de beroepsinkomsten en auteursvergoeding apart door naar jou.',
        download: 'Je factuur downloaden',
        eyebrow: 'Factuur voor jou',
        highlight: 'Jij ontvangt',
      },
      performanceGroup: 'Beroepsinkomsten',
      title: 'Waarom 2 facturen?',
      totalInclVat: 'Totaal (incl. btw)',
    },
    statusInfo: {
      message: {
        Approved: {
          default: 'Je factuur is goedgekeurd en verstuurd naar je klant.',
        },
        CoPaid: {
          default: 'Je klant heeft de factuur betaald. De betaling ontvang jij van Creative Shelter de eerstvolgende werkdag.',
        },
        Credited: {
          default: 'Deze factuur crediteerde je.<br>Creditnotanummer: {{creditNoteNumber}}.<br>Reden: {{creditNoteReason}}',
        },
        Expired: {
          coPartiallyPaid: 'We ontvingen een gedeeltelijke betaling van je klant. Hieronder kan je de betalingen in detail opvolgen.',
          default:
            'Je factuur is vervallen. We volgen dit verder voor je op met je klant volgens <a href="https://knowledge.creativeshelter.be/wat-als-mijn-klant-opdrachtgever-nog-niet-betaald-heeft-op-de-vervaldag" target="_blank">onze richtlijnen</a>.',
          followingUp:
            'Je factuur is niet binnen de vervaltermijn betaald door je klant. Om de betaling te bekomen, hebben we de nodige opvolging gestart. Hieronder kan je elke stap volgen.',
        },
        FcPaid: {
          default: 'Je factuur werd uitbetaald. Hieronder vind je de betalingen in detail.',
        },
        InReview: {
          default:
            'We hebben je factuur ontvangen en keuren deze zo snel mogelijk goed. Nog sneller factureren? <a href="https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze" target="_blank">Ontdek hier</a> hoe je producten kan gebruiken om instant te factureren.',
        },
        LockedByUser: {
          default:
            'Je factuur staat in bewerking. Dat wil zeggen dat wij deze niet kunnen controleren, goedkeuren en verzenden naar je klant. Verstuur je deze opnieuw als deze is aangevuld/aangepast?',
        },
      },
      title: {
        inReview: 'Verstuurd ter goedkeuring',
        paymentFollowUp: 'Betaling in opvolging',
        sentWithPeppol: 'Verstuurd via Peppol',
      },
    },
    summary: {
      client: {
        noClient: 'Geen klant geselecteerd.',
      },
      content: {
        noDescription: 'Geen beschrijving ingevuld.',
      },
      copyright: {
        conditionsChecklist: {
          onlineCourse: {
            item1: 'Je geeft Creative Shelter toestemming om je cursus beschikbaar te stellen aan je klant.',
            item2: 'Je klant mag je cursus bekijken, bewaren of printen voor eigen gebruik.',
            item3: 'Verdere verspreiding of publicatie is niet toegestaan.',
          },
          rightOfUse: {
            item1: 'Je blijft eigenaar van je werk.',
            item2: 'Je klant krijgt het recht om je werk te gebruiken zoals bedoeld (bv. tonen of verspreiden).',
            item3: 'Dit recht geldt onbeperkt in duur, plaats en vorm (tenzij anders afgesproken).',
          },
          transfer: {
            item1: 'Je draagt de rechten op je werk over aan je klant.',
            item2: 'Je werk mag wereldwijd en onbeperkt gebruikt, bewerkt en verspreid worden.',
            item3: 'Je blijft maker, maar bent geen juridische eigenaar meer (tenzij anders afgesproken).',
          },
        },
        noConditions: 'Geen voorwaarden geselecteerd.',
        notAvailable: 'Niet beschikbaar',
        type: {
          condition: 'Algemene voorwaarden',
          customCondition: 'Custom algemene voorwaarden',
        },
        viewPdf: 'Pdf bekijken',
      },
      lines: {
        noLines: 'Geen factuurlijnen toegevoegd.',
      },
    },
    timeline: {
      title: 'Tijdlijn',
    },
  },
  fields: {
    billingPeriod: {
      helpText: 'Vervaldatum <0>{{ date }}</0>',
      label: 'Betalingstermijn',
      options: {
        '15': '15 dagen',
        '30': '30 dagen',
        '45': '45 dagen',
        '60': '60 dagen',
      },
    },
    billingPeriodEndOfMonth: {
      label: 'Einde maand',
      tooltip: 'Bereken de betalingstermijn vanaf het einde van de maand.',
    },
    brandId: {
      label: 'Handelsnaam',
      placeholder: 'Selecteer een handelsnaam',
    },
    clientId: {
      add: 'Klant toevoegen',
      label: 'Klant',
      placeholder: 'Selecteer een klant',
    },
    condition: {
      label: 'Hoe draag jij je auteursrechten over?',
      link: 'Voorwaarden nalezen',
      placeholder: 'Selecteer een regime',
    },
    contactId: {
      add: 'Contactpersoon toevoegen',
      placeholder: 'Selecteer een contactpersoon',
    },
    customAgreementId: {
      description_one:
        'Je hebt al een lopende overeenkomst met {{name}}. Wij verwijzen automatisch naar jouw overeenkomst, je hoeft niets te doen.',
      description_other: 'Je hebt meerdere lopende overeenkomsten met {{name}}. Kies hier binnen welke overeenkomst dit document kadert.',
      label: 'Raamovereenkomst',
      placeholder: 'Selecteer een raamovereenkomst',
    },
    description: {
      label: 'Beschrijving',
      placeholder: 'Beschrijf kort wat je opdracht inhoudt',
    },
    entryNumber: {
      label: 'Factuurnummer',
    },
    numberingSeriesId: {
      helpText: 'Het factuurnummer zal <0>{{entryNumber}}</0> zijn.',
      label: 'Nummeringreeks',
      labelTooltip:
        'Vragen over het aanmaken van een nummeringreeks? Klik <a href="https://knowledge.creativeshelter.be/wat-is-een-nummeringreeks-en-hoe-stel-ik-deze-in" target="_blank">hier</a> voor meer informatie.',
      none: 'Geen nummeringreeks',
      placeholder: 'Selecteer een nummeringreeks',
      tooltip: 'Dit is een preview van je factuurnummer. Je nummer zelf is pas definitief als je de factuur naar ons verstuurt.',
      tooltipCreate:
        'Een nummeringreeks helpt je je facturen correct en vlot te nummeren. Je kan er zoveel aanmaken als je wilt, maar één is voldoende. Lees je er graag meer over, of zit je nog met vragen? <a href="https://knowledge.creativeshelter.be/wat-is-een-nummeringreeks-en-hoe-stel-ik-deze-in" target="_blank">Dat kan hier.</a>',
    },
    orderReference: {
      label: 'PO-nummer/bestelbon klant',
      placeholder: 'PO-nummer/bestelbon klant',
    },
    remark: {
      label: 'Opmerkingen',
      placeholder: 'Nog een extra opmerking of vraag voor je factuur, gericht aan Creative Shelter? Die vul je hier in!',
    },
    specialConditions: {
      custom: 'Dit document kadert in onze overeenkomst dd. {{date}}',
      label: 'Bijzondere voorwaarden',
      placeholder: 'Vul hier eventuele bijzondere voorwaarden in.',
    },
    title: {
      label: 'Titel',
      placeholder: 'Titel',
    },
  },
  header: {
    actionBlock: {
      button: 'Factuur aanmaken',
      dropdown: {
        creditnote: 'Creditnota aanmaken',
        invoiceTemplate: 'Factuurtemplate aanmaken',
        notCreative: 'Niet-creatieve factuur (Billit)',
      },
    },
    title: 'Facturen',
  },
  overview: {
    columns: {
      client: 'Klant',
      date: 'Factuurdatum',
      days: 'dagen',
      dueDate: 'Vervaldatum',
      entryNumber: 'Factuur',
      saved: 'Voordeel',
      status: {
        lockedByUserTooltip:
          'Oeps! Deze factuur staat in ‘bewerkmodus’, dus we kunnen ze niet goedkeuren. Klik op ‘Bewerk factuur’ om je factuur te versturen.',
        options: {
          Approved: 'Verstuurd',
          CoPaid: 'Betaald',
          Credited: 'Gecrediteerd',
          Draft: 'Concept',
          Expired: 'Vervallen',
          FcPaid: 'Uitbetaald',
          InReview: 'Ter goedkeuring',
          LockedByUser: 'In bewerking',
        },
        sentWithPeppolTooltip: 'via Peppol',
        title: 'Status',
      },
      substatus: {
        CoPartiallyPaid: 'Gedeeltelijk betaald',
        PaymentInFollowUp: 'Betaling in opvolging',
      },
      total: 'Totaal (excl. btw)',
    },
    created: {
      subtitle: 'Facturen',
    },
    createdFromTemplateTooltip: 'Deze factuur is aangemaakt vanuit een template.',
    emptyState: {
      completeAccount: 'Account vervolledigen',
      createInvoice: 'Factuur aanmaken',
      text: 'Maak snel en eenvoudig een nieuwe factuur. In een paar stappen is ze klaar om te versturen.',
      title: 'Klaar om je eerste factuur aan te maken?',
    },
    error: {
      title: 'Fout bij het laden van je facturen.',
    },
    lockedByAdmin: {
      description: 'Factuur met nummer {{number}} kan niet meer bewerkt worden omdat we deze al aan het goedkeuren zijn.',
      title: 'Factuur kan niet bewerkt worden.',
    },
    rowActions: {
      advantage: 'Voordeel bekijken',
      credit: 'Crediteren',
      details: 'Meer details',
      download: 'Downloaden',
      duplicate: 'Kopiëren',
      edit: {
        error: 'Er ging iets mis bij het openen van de factuur. Probeer je het later nog eens?',
        label: 'Bewerken',
      },
      preview: 'Klantenfactuur bekijken',
      resendCoInvoice: 'Opnieuw versturen',
    },
  },
};
